export const setDataSearchListClaimRecon = (payload) => {
  return {
    type: "SET_DATA_SEARCH_LIST_CLAIM_RECON",
    payload,
  }
}

export const resetListClaimRecon = (payload) => {
  return {
    type: "RESET_LIST_CLAIM_RECON",
    payload,
  }
}
